export const LOCALS = {
  EN: 'en',
  UK: 'uk',
};
